/* global G */
import { withGetterSetter } from 'lib/trait/with'
import { pipe } from 'lib/util'
import drop from 'model/_shared/transformer/drop'
import toBoolean from 'model/_shared/transformer/toBoolean'
import { modelComposition } from 'trait/composition'
import { usesGetterSetter } from 'trait/uses'
import toInt from 'model/_shared/transformer/toInt'
import toRef from 'model/_shared/transformer/toRef'
import fromSingleRef from 'model/_shared/decorator/fromSingleRef'
import validator from './validator/measurement'

const descriptor = 'model::xEcoApm::measurement'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, validator),
  usesGetterSetter(G.TRANSFORMER, {
    reference: toBoolean('reference'),
    submit: drop('submit'),
    submitter: toRef('submitter'),
    item: toRef('item'),
    organisation: toRef('organisation'),
  }),
  withGetterSetter(G.DECORATOR),
  usesGetterSetter(G.DECORATOR, {
    submitter: fromSingleRef('submitter', 'submitter'),
    item: fromSingleRef('item', 'item'),
    organisation: fromSingleRef('organisation', 'organisation'),
  }),
)
